import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';

import { ChevronDown } from 'lucide-react';
import React, { useCallback, useState } from 'react';
import { Controller } from 'react-hook-form';

export const DropdownInput = ({ control, items, defaultValue }: { control: any; items: any; defaultValue: any }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  // Toggle menu open state
  const toggleMenu = useCallback(() => setMenuOpen((prev) => !prev), []);

  return (
    <div className="flex flex-col mb-2 ">
      <Controller
        control={control}
        name="component"
        defaultValue={defaultValue} // Default value for the select
        render={({ field }) => (
          <>
            <DropdownMenu open={menuOpen} onOpenChange={toggleMenu}>
              <label className={cn(' text-xs ml-4', menuOpen ? 'text-primary-600' : 'text-gray-500')}>
                Razor Component Name
              </label>
              <DropdownMenuTrigger asChild className="min-w-[220px]">
                <Button
                  variant="ghost"
                  className={cn(
                    'py-2 text-md font-normal border-b-2 border-t-0 border-x-0 border-gray-300 rounded-none focus:border-primary-500 bg-white hover:bg-white justify-between mx-2 pl-1 pr-2',
                    `${menuOpen ? 'border-primary-500' : ''}`
                  )}
                  data-testid="field_razor_component_name"
                >
                  {field.value || 'Razor Components '}
                  <span className={`${menuOpen && 'rotate-[180deg]'}`}>
                    <ChevronDown />
                  </span>
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent
                align="start"
                className="w-[var(--radix-popper-anchor-width)] flex flex-1 flex-col !bg-white"
              >
                {[{ id: null, component_ui_name: null }, ...items].map((item: any) => (
                  <DropdownMenuItem
                    className="min-h-8"
                    key={item.id}
                    onClick={() => {
                      field.onChange(item.component_ui_name); // Update the form value
                      toggleMenu(); // Close the dropdown after selection
                    }}
                  >
                    {item.component_ui_name}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>
          </>
        )}
      />
    </div>
  );
};
